import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import config from "../data/config";
import "./main.css";
import FontLoader from "./fontLoader";
import OGImage from "../images/transaction-fees/hero_visas.png";

const PageTitle =
  "Process Credit Card Payments - Accept payments anywhere in SA → Yoco®";

const criteoHome = `var dataLayer = dataLayer || [];
    dataLayer.push({
        event: 'crto_homepage',
        crto: {
            email: '##Users Email##' //can be empty string if email not known
        }
    });`;

const criteoProduct = `var dataLayer = dataLayer || [];
    dataLayer.push({
        event: 'crto_productpage',
        crto: {
            email: '', //can be empty string if email not known
            products: ['Pro']
        }
    });`;

const criteoBasket = `var dataLayer = dataLayer || [];
dataLayer.push({
  event: 'crto_basketpage',
  crto: {
    email: '',  //can be empty string if email not known
    products: [{
      id: 'Pro',
      price: '2799',
      quantity: '1'
    }] //add new object for each product added to cart.
  }
});`;

function checkCriteoTag(path) {
  let dataLayer = "";

  switch (path) {
    case "/za/":
      dataLayer = criteoHome;
      break;
    case "/za/about/":
      dataLayer = criteoHome;
      break;
    case "/za/credit-card-readers/":
      dataLayer = criteoProduct;
      break;
    case "/za/point-of-sale-app/":
      dataLayer = criteoProduct;
      break;
    case "/za/portal/":
      dataLayer = criteoProduct;
      break;
    case "/za/capital/":
      dataLayer = criteoProduct;
      break;
    case "/za/signup/":
      dataLayer = criteoBasket;
      break;

    default:
      dataLayer = "";
  }

  if (dataLayer.length != 0) {
    return <script type="text/javascript">{dataLayer}</script>;
  }
}

const TemplateWrapper = props => {
  const children = props.children;

  return (
    <div>
      <Helmet
        title={PageTitle}
        meta={[
          {
            name: "description",
            content:
              "Process Credit Card Payments and start your business empire with Yoco, the #1 mobile card reader for South African small & medium businesses."
          }
        ]}
      >
        <meta content={OGImage} property="og:image" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />

        {checkCriteoTag(props.location.pathname)}

        <script>
          {`
          LUX = window.LUX || {};
          LUX.samplerate = 100;
          `}
        </script>
        <script
          src="https://cdn.speedcurve.com/js/lux.js?id=157745041"
          async={"true"}
          defer={"true"}
        />

        <script key="fontLoader" type="text/javascript">
          {FontLoader.script()}
        </script>

        <script>
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-N65QCC2');`}
        </script>

        {/* Add our script for segment tracking so that this is now working...*/}
        <script key="segment" type="text/javascript">
          {`
          !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t,e){var n=document.createElement("script");n.type="text/javascript";n.async=!0;n.src="https://cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.1.0";
            setTimeout(function(){analytics.load("${
              config.segmentPublicKey
            }")}, 1000);
            // called each time the page is loaded...
            analytics.page();
          }}();`}
        </script>
        <script type="text/javascript">{`(function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;h.start=1*new Date;
        h.end=i=function(){s.className=s.className.replace(RegExp(' ?'+y),'')};
        (a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;
        })(window,document.documentElement,'async-hide','dataLayer',500,
        {'GTM-XXXXXX':true});`}</script>

        <style type="text/css">{`.async-hide { opacity: 0 !important}`}</style>
      </Helmet>

      <div style={{ backgroundColor: "white" }}>{children()}</div>

      <div>
        {/* Add zendesk chat*/}
        <script
          key="zdChat"
          type="text/javascript"
          dangerouslySetInnerHTML={{
            __html: `setTimeout(function(){${config.zendDesk}}, 4000);`
          }}
        />

        {/* Lazy loading of images */}
        <script
          type="text/javascript"
          dangerouslySetInnerHTML={{
            __html: `
              function checkAsyncImages() {
                [].forEach.call(document.querySelectorAll('img[data-src]'), function(img) {
                  img.setAttribute('src', img.getAttribute('data-src'));
                  img.onload = function() {
                    img.removeAttribute('data-src');
                  };
                });

                [].forEach.call(document.querySelectorAll('[data-src-bck]'), function(div) {
                  div.style.backgroundImage = "url(" + div.getAttribute("data-src-bck") + ")";
                  div.removeAttribute("data-src-bck");
                });
              }

              window.addEventListener('load', function() {
                checkAsyncImages();

                setInterval(checkAsyncImages, 500);
              });
            `
          }}
        />
      </div>
    </div>
  );
};
TemplateWrapper.propTypes = {
  children: PropTypes.func
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js